import { Box, Typography } from "@mui/joy";
import Add from '@mui/icons-material/Add';
import React, { useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { RouteComponentProps } from "../../models/RouteComponent";
import { getIncidentType, removeIncidentType } from "../../service/incidentTypeService";
import IncidentTypeAdd from "./incident-types-Add";

export default function IncidentTypesView(props: RouteComponentProps) {
  const [selectedType, setType] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const baseFilter = {
    'name': { value: '', matchMode: FilterMatchMode.CONTAINS }
  }

  const addButton = (row: any) => {
    setType(null);
    setVisible(true);
  }

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row.value);
    setType(row.value);
    editConfirm(row);
  }

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row.value);
    setType(row.value);
  }

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    await removeIncidentType(selectedType.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: 'success', summary: 'Incident Type Deleted Successfully', life: 3000 });
  }

  const editConfirm = (row: any) => {
    setVisible(true);
  }

  const deleteConfirm = async (row: any) => {
    confirmDialog({
      message: 'Are you sure you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => acceptFunc()
    });
  }

  const contextItems = () => {
    let objArray = [
      { label: 'Edit', icon: 'pi pi-fw pi-pencil', command: editConfirm },
    ];
    objArray.push({ label: 'Delete', icon: 'pi pi-fw pi-trash', command: deleteConfirm });
    return objArray;
  }

  const columns: GenericTableColumns[] = [
    {
      field: 'name',
      header: 'Name',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
    {
      field: 'description',
      header: 'Description',
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: false,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [{
          label: '',
          value: ''
        }]
      }
    },
  ];

  return (
    <React.Fragment>
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level="h2" component="h1">
          Incident Types
        </Typography>
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url="incident/type"
        columns={columns}
        contextItems={contextItems}
        addButton={addButton}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        ref={dialog}
        header={selectedType?.id ? 'Update Incident Type' : 'Add Incident Type'}
        visible={visible}
        style={{ width: '50vw' }}
        onHide={() => setVisible(false)}
      >
        <IncidentTypeAdd
          id={selectedType?.id}
          setVisible={setVisible}
          setGlobalLoading={props.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          toast={toast}
        />
      </Dialog>

      <ConfirmDialog />
      <Toast ref={toast} />
    </React.Fragment>
  );
}
